import React, { useState, useEffect } from "react";
import styled from "styled-components";
import logo from "../../assets/logo.png";
import UsuariosService from "../../service/usuario";
import RegioesService from "../../service/regioes";

export default function ModalNovidades() {
  const [show, setShow] = useState(false);
  const [exibirRecursosGerais, setExibirRecursosGerais] = useState(false);

  useEffect(() => {
    let ativo = true;

    const carregarPermissao = async () => {
      const userId = localStorage.getItem("idUsuario");
      if (!userId) return;

      let perfisArr = [];
      try {
        const raw = localStorage.getItem("perfilUsuario");
        const perfis = raw ? JSON.parse(raw) : [];
        perfisArr = Array.isArray(perfis) ? perfis : perfis ? [perfis] : [];
      } catch (e) {
        const raw = localStorage.getItem("perfilUsuario");
        perfisArr = raw ? [raw] : [];
      }

      const isAdmin = perfisArr.includes("admin");
      const isCoordenadorGeral = perfisArr.includes("coordenador-geral");
      const isCoordenadorRegional = perfisArr.includes("coordenador-regional");
      const isCoordenadorPonto = perfisArr.includes("coordenador-ponto");

      let permitido = isAdmin || isCoordenadorGeral;

      if (!permitido && (isCoordenadorRegional || isCoordenadorPonto)) {
        try {
          const usuario = await UsuariosService.getUsuarioById(userId);

          const possuiPontoEventos = (Array.isArray(usuario?.pontos)
            ? usuario.pontos
            : []
          ).some(
            (ponto) => String(ponto?.nome || "").trim().toLowerCase() === "eventos"
          );

          let possuiRegiaoEventos = false;
          if (isCoordenadorRegional) {
            try {
              const regioes = await RegioesService.getRegioes(true);
              possuiRegiaoEventos = (Array.isArray(regioes) ? regioes : []).some(
                (regiao) =>
                  String(regiao?.nome || "").trim().toLowerCase() === "eventos"
              );
            } catch (error) {
              possuiRegiaoEventos = false;
            }
          }

          permitido =
            (isCoordenadorPonto && possuiPontoEventos) ||
            (isCoordenadorRegional && possuiRegiaoEventos);
        } catch (error) {
          permitido = false;
        }
      }

      if (!permitido || !ativo) return;

      setExibirRecursosGerais(isAdmin || isCoordenadorGeral);

      const currentKey = `hideNovidadesV2_${userId}`;
      if (localStorage.getItem(currentKey) !== "true") {
        setShow(true);
      }
    };

    carregarPermissao();

    return () => {
      ativo = false;
    };
  }, []);

  const salvarPreferenciaNaoExibir = () => {
    const userId = localStorage.getItem("idUsuario");
    if (userId) {
      localStorage.setItem(`hideNovidadesV2_${userId}`, "true");
    }
  };

  const handleClose = () => {
    salvarPreferenciaNaoExibir();
    setShow(false);
  };

  if (!show) return null;

  return (
    <WelcomeOverlay>
      <WelcomeContent>
        <HeaderDecoration>
          <CloseButton onClick={handleClose}>&times;</CloseButton>
          <LogoWrapper>
            <WelcomeLogo src={logo} alt="Logo TPEDF" />
          </LogoWrapper>
        </HeaderDecoration>
        <BodyContent>
          <WelcomeTitle>Novidades</WelcomeTitle>
          <WelcomeMessage>
            <NovidadesLista>
              <NovidadeItem>
                <NovidadeIcone>🔄</NovidadeIcone>
                <NovidadeTexto>
                  <strong>Substituição de publicador direto na tela inicial</strong><br />
                  Publicadores que cancelaram agora aparecem com a opção <em>Substituir Publicador</em> na própria tabela — sem precisar abrir outra tela.
                </NovidadeTexto>
              </NovidadeItem>
              <NovidadeItem>
                <NovidadeIcone>🔍</NovidadeIcone>
                <NovidadeTexto>
                  <strong>Filtro de disponíveis na seleção de publicadores</strong><br />
                  A janela de substituição agora exibe apenas os publicadores com disponibilidade para aquele ponto, dia e horário — facilitando muito a escolha.
                </NovidadeTexto>
              </NovidadeItem>
              <NovidadeItem>
                <NovidadeIcone>👥</NovidadeIcone>
                <NovidadeTexto>
                  <strong>Até 3 publicadores de uma só vez</strong><br />
                  Agora é possível adicionar ou trocar até 3 publicadores numa única operação, sem precisar abrir e fechar a janela várias vezes.
                </NovidadeTexto>
              </NovidadeItem>
              {exibirRecursosGerais && (
                <NovidadeItem>
                  <NovidadeIcone>✅</NovidadeIcone>
                  <NovidadeTexto>
                    <strong>Confirmação de inscrições por turno</strong><br />
                    Secretárias de eventos agora podem visualizar e confirmar as inscrições organizadas por turno, diretamente na lista de inscritos do evento.
                  </NovidadeTexto>
                </NovidadeItem>
              )}
            </NovidadesLista>
          </WelcomeMessage>
          <ConfirmButton onClick={handleClose}>Entendi, vamos lá!</ConfirmButton>
        </BodyContent>
      </WelcomeContent>
    </WelcomeOverlay>
  );
}

const WelcomeOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(1px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
  overflow-y: auto;
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @media (max-width: 600px) {
    align-items: flex-start;
    padding: 16px;
  }
`;

const WelcomeContent = styled.div`
  background: white;
  border-radius: 20px;
  width: 600px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;

  @media (max-width: 600px) {
    max-height: none;
    border-radius: 16px;
    margin: auto 0;
  }
  text-align: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes slideUp {
    from { opacity: 0; transform: translateY(40px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
`;

const HeaderDecoration = styled.div`
  width: 100%;
  height: 60px;
  background: linear-gradient(135deg, #006666 0%, #004d4d 100%);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 20px;
  margin-bottom: 35px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 30px;
    background: white;
    border-radius: 20px 20px 0 0;
  }
`;

const LogoWrapper = styled.div`
  background: white;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
`;

const WelcomeLogo = styled.img`
  width: 55px;
  object-fit: contain;
`;

const BodyContent = styled.div`
  padding: 0 30px 30px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const WelcomeTitle = styled.h2`
  color: #006666;
  margin: 10px 0 12px 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.5px;
`;

const WelcomeMessage = styled.div`
  color: #4a5568;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 24px 0;
  text-align: left;
  width: 100%;

  strong {
    color: #006666;
    font-weight: 600;
  }

  em {
    font-style: normal;
    font-weight: 500;
    color: #374151;
  }
`;

const NovidadesLista = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const NovidadeItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f0fafa;
  border-left: 3px solid #008080;
  border-radius: 0 8px 8px 0;
  padding: 10px 12px;
`;

const NovidadeIcone = styled.span`
  font-size: 18px;
  line-height: 1.4;
  flex-shrink: 0;
`;

const NovidadeTexto = styled.span`
  font-size: 13px;
  line-height: 1.55;
  color: #374151;
`;

const ConfirmButton = styled.button`
  background: linear-gradient(to right, #006666, #008080);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(0, 102, 102, 0.3);
  width: 100%;
  max-width: 260px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 102, 102, 0.4);
    filter: brightness(1.1);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 10px rgba(0, 102, 102, 0.2);
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: background 0.2s;
  z-index: 3;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;
